// extracted by mini-css-extract-plugin
module.exports = {"box":"ThirdStep_box__1E1Bh","label":"ThirdStep_label__nhbl5"};